import i18n from '@config/i18n';
import { format, parseISO } from 'date-fns';

/**
 * Formato de data e hora por idioma (a ordem dia/mês e o relógio de 12 ou 24 h mudam com a
 * LÍNGUA escolhida, não com o país). Lê o idioma atual do i18n a cada chamada: as telas já
 * re-renderizam quando ele muda (usam `useTranslation`).
 */
const PADROES = {
  pt: { dia: 'dd/MM/yyyy', hora: 'HH:mm', horaSeg: 'HH:mm:ss', ciclo: 24 as const },
  en: { dia: 'MM/dd/yyyy', hora: 'hh:mm a', horaSeg: 'hh:mm:ss a', ciclo: 12 as const },
  es: { dia: 'dd/MM/yyyy', hora: 'HH:mm', horaSeg: 'HH:mm:ss', ciclo: 24 as const },
};

export function padroesDoIdioma(idioma: string = i18n.language) {
  const base = idioma.slice(0, 2).toLowerCase() as keyof typeof PADROES;
  return PADROES[base] ?? PADROES.pt;
}

/** `YYYY-MM-DD` ou timestamp ISO → só a data, no formato do idioma. */
export const formatarDia = (iso: string) => format(parseISO(iso), padroesDoIdioma().dia);

/** Timestamp ISO → data e hora (no fuso do navegador), no formato do idioma. */
export function formatarDataHora(iso: string) {
  const p = padroesDoIdioma();
  return format(parseISO(iso), `${p.dia} ${p.hora}`);
}

/** Igual a `formatarDataHora`, com segundos (progresso de rodadas). */
export function formatarDataHoraSeg(iso: string) {
  const p = padroesDoIdioma();
  return format(parseISO(iso), `${p.dia} ${p.horaSeg}`);
}

/** Dia e mês sem o ano (`dd/MM` ou `MM/dd`), para listas compactas. */
export const formatarDiaCurto = (iso: string) =>
  format(parseISO(iso), padroesDoIdioma().dia.replace(/\/?yyyy\/?/, ''));

/** Dia e mês com a hora (`dd/MM HH:mm`). */
export function formatarDataHoraCurta(iso: string) {
  const p = padroesDoIdioma();
  return format(parseISO(iso), `${p.dia.replace(/\/?yyyy\/?/, '')} ${p.hora}`);
}
